<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :countrys="countrys"
      :filterProp="filterProp"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        @openEditShipping="openEditShipping"
        :countrys="countrys"
        :filterProp="filterProp"
        @clearKey="clearKey"
      />
      <router-view
        :first_loading="firstLoading"
        :items="items"
        @modiShipping="openEditShipping"
        @changeStatus="changeStatus"
        @delShipping="delShipping"
        @popContact="popContact"
      >
      </router-view>
      <Pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/int-shippingfee/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
      <api-loading :show="loading"></api-loading>
    </div>
    <ModalEditShipping
      :open="openModalEditShipping"
      :countrys="countrys"
      :info="modalEditShippingItem"
      @saveSuccess="saveEditShippingSuccess"
    />
    <Modal
      :modalId="'modalDelINTShipping'"
      :home="false"
      :loading="modalDelINTShipping.loading"
      :size="'sm'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("express.删除物流渠道") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <p>
            {{ $t("express.确定要删除") }}
            <span class="tx-danger">{{ modalDelINTShipping.name }}</span>
            {{ $t("express.吗？") }}
          </p>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-30
                btn btn-danger
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="confirmDelINTShipping()"
            >
              {{ $t("express.删除") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("express.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Popover
      :id="'editMobile'"
      :loading="popEditMobile.loading"
      v-show="
        $store.state.popover.id == 'editMobile' && $store.state.popover.open
      "
      :style="{
        opacity:
          $store.state.popover.id == 'editMobile' && $store.state.popover.open
            ? 1
            : 0,
      }"
    >
      <template slot="body">
        <div class="pop-inner">
          <template v-if="popEditMobile.item">
            <div class="d-flex align-items-center">
              <div class="mg-b-10">
                <p class="mg-b-5">
                  <span class="mg-r-10">{{ popEditMobile.item.name }}:</span
                  >{{
                    popEditMobile.item.ruleType == 1
                      ? $t("express.按单收运费")
                      : ""
                  }}
                  {{
                    popEditMobile.item.ruleType == 2
                      ? $t("express.按重量收运费")
                      : ""
                  }}
                  {{
                    popEditMobile.item.ruleType == 3
                      ? $t("express.按件收运费")
                      : ""
                  }}
                </p>
                <p class="mg-b-5" v-if="popEditMobile.item.ruleType == 1">
                  {{ $t("express.每单")
                  }}{{ showRuleJson(popEditMobile.item.ruleJson).everyFee
                  }}{{ $t("express.元") }}
                </p>
                <p class="mg-b-5" v-if="popEditMobile.item.ruleType == 2">
                  <span
                    class="d-block"
                    v-for="(rule, index) in showRuleJson(
                      popEditMobile.item.ruleJson
                    )"
                    :key="index"
                  >
                    <span class="mg-b-5 d-block">
                      {{ rule.start }}{{ $t("express.克") }} --- {{ rule.end
                      }}{{ $t("express.克，") }}
                    </span>
                    <span class="mg-b-5 d-block">
                      {{ $t("express.首重") }}{{ rule.startWeight
                      }}{{ $t("express.克，运费") }}{{ rule.startPrice
                      }}{{ $t("express.元，") }}
                    </span>
                    <span class="mg-b-5 d-block">
                      {{ $t("express.每续重") }}{{ rule.incWeight
                      }}{{ $t("express.克，运费加") }}{{ rule.incPrice
                      }}{{ $t("express.元，") }}
                    </span>
                  </span>
                </p>
                <p class="mg-b-5" v-if="popEditMobile.item.ruleType == 3">
                  <span class="mg-b-5 d-block">
                    {{ $t("express.首件，运费")
                    }}{{ showRuleJson(popEditMobile.item.ruleJson).startPrice
                    }}{{ $t("express.元，") }}
                  </span>
                  <span class="mg-b-5 d-block">
                    {{ $t("express.后续每件，运费")
                    }}{{ showRuleJson(popEditMobile.item.ruleJson).incPrice
                    }}{{ $t("express.元，") }}
                  </span>
                </p>
              </div>
            </div>
          </template>
        </div>
      </template>
    </Popover>
  </div>
</template>

<script>
import Popover from "@components/Popover.vue";
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import Modal from "@components/Modal";
import { pagination } from "@components/pagination.js"; //分页
import ModalEditShipping from "./ModalEditShipping";

export default {
  components: {
    LeftSide,
    Header,
    Pagination: pagination,
    ModalEditShipping,
    Modal,
    Popover,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("INT-shippingfee-rowsPerPage"))
        ? parseInt(store.get("INT-shippingfee-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      items: [],
      filterProp: {
        logistics: "",
        status: "",
        countryCode: "",
      },
      countrys: [], //国家
      openModalEditShipping: Symbol(),
      modalEditShippingItem: null,
      modalDelINTShipping: {
        loading: false,
        id: "",
        name: "",
      },
      popEditMobile: {
        loading: false,
        item: "",
        id: "", //id 修改数据用
      },
      popEditMobileDefault: "",
    };
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("INT-shippingfee-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getCountrys();
    this.getItem();
    this.popEditMobileDefault = JSON.stringify(this.popEditMobile);
  },
  methods: {
    showRuleJson(val) {
      if (!val) return;
      return JSON.parse(val);
    },
    popContact(event, item, id, position) {
      if (event.type == "mouseenter") {
        //打开
        this.$store.commit("setPopover", {
          id,
          event,
        });
        switch (id) {
          case "editMobile":
            this.popEditMobile = JSON.parse(this.popEditMobileDefault);
            this.popEditMobile.id = item.id;
            //							if(item.ruleType == 2){
            //								item.ruleJson = JSON.parse(item.ruleJson);
            //							}
            this.popEditMobile.item = item;
            break;
        }
      } else {
        this.$store.commit("setPopover", {
          event,
        });
      }
    },
    clearKey(type) {
      this.filterProp[type] = "";
      //筛选都回第一页
      this.toPage(1);
    },
    filtrate(Logistics, CountryCode, Status) {
      this.filterProp.logistics = Logistics;
      this.filterProp.countryCode = CountryCode;
      this.filterProp.status = Status;
      //筛选都回第一页
      this.toPage(1);
    },
    confirmDelINTShipping() {
      this.modalDelINTShipping.loading = true;
      $.api_call(
        "api.InterShipping.delete",
        {
          id: this.modalDelINTShipping.id,
        },
        (r) => {
          this.modalDelINTShipping.loading = false;
          if (r.ErrorCode == "9999") {
            $("#modalDelINTShipping").modal("hide");
            ShowTip(this.$t("express.删除成功"), "success");
            this.getItem(true);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    delShipping(item) {
      this.modalDelINTShipping.loading = false;
      this.modalDelINTShipping.id = item.id;
      this.modalDelINTShipping.name = item.logistics;
      $("#modalDelINTShipping").modal("show");
    },
    changeStatus(item, status) {
      //启用和不启用
      this.loading = true;
      $.api_call(
        "api.InterShipping.changeStatus",
        {
          id: item.id,
          status,
        },
        (r) => {
          this.loading = true;
          if (r.ErrorCode == "9999") {
            ShowTip(
              `${
                status == 1 ? this.$t("express.启用") : this.$t("express.停用")
              }${this.$t("express.成功")}`,
              "success"
            );
            this.getItem(true);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    saveEditShippingSuccess() {
      this.getItem(true);
      $("#ModalEditShipping").modal("hide");
    },
    openEditShipping(item) {
      this.openModalEditShipping = Symbol();
      if (item) {
        this.modalEditShippingItem = item;
      } else {
        this.modalEditShippingItem = null;
      }
      $("#ModalEditShipping").modal("show");
    },
    getItem(s) {
      //获取物流
      this.loading = true;
      $.api_call(
        "api.InterShipping.findBySupplier",
        {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
          logistics: this.filterProp.logistics,
          status: this.filterProp.status,
          countryCode: this.filterProp.countryCode,
        },
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            this.items = [];
            r.Data.Results.forEach((e) => {
              //            e.ruleJson = JSON.parse(e.ruleJson);
              this.items.push(e);
            });
            this.totalPage = r.Data.Pagination.totalPage;
            this.totalCount = r.Data.Pagination.totalCount;
            if (!s) $("html,body").scrollTop(0);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    getCountrys() {
      // 获取国家
      $.api_call("api.InterShipping.getCountrys", {}, (r) => {
        if (r.ErrorCode == "9999") {
          this.countrys = [];
          let countrys = r.Data.Results.country;
          Object.keys(countrys).forEach((key) => {
            let sub = [];
            Object.keys(countrys[key]).forEach((k) => {
              countrys[key][k].checked = false;
              sub.push(countrys[key][k]);
            });
            this.countrys.push({
              name: key,
              checked: false,
              active: false,
              sub,
            });
            this.$set(this.countrys[0], "active", true);
          });
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({
        name: "int-shippingfee-list",
        params: {
          page: 1,
        },
      });
      if (page == 1) {
        this.getItem();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({
        name: "int-shippingfee-list",
        params: {
          page: num,
        },
      });
      if (page == num) {
        this.getItem();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItem();
    },
  },
};
</script>